// extracted by mini-css-extract-plugin
export var center = "_5o-2";
export var clickableRow = "_5o-5";
export var expandedRow = "_5o-7";
export var hoverable = "_5o-4";
export var left = "_5o-1";
export var right = "_5o-3";
export var row = "_5o-0";
export var selectedRow = "_5o-6";
export var summaryRow = "_5o-8";